import src from '../assets/draperindoorgolf.png';
import { imageLogo } from './imageLogo';

/**
 * Draper Indoor Golf — square badge: black golf-clock icon on a white plate.
 * The white ground is opaque, so on light surfaces the mark reads as a clean
 * badge. On the dark canvas the dark-surface variant (draperindoorgolf-dark)
 * is used instead.
 */
export const DraperIndoorGolfLogo = imageLogo({
  src,
  width: 1024,
  height: 1024,
  alt: 'Draper Indoor Golf',
});
